export default {
  apiUrl: 'https://api.hirsch-apotheke-korbach.de',
  api2Url: 'https://api2.hirsch-apotheke-korbach.de',
};
